<template>
  <div id="db_class_wrap">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
a {
  text-decoration: none !important;
}
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: auto;
}
.el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue